import { cloneDeep } from 'lodash';

import { CommunicationSessionType } from '../../../../../objects/call/communication-session-type';
import { SerializableObjectSchema } from '../../../../../objects/generic/serialization/serializable-object-schema';
import { CommunicationsRequestName } from '../../../communications-request-name';
import { CommunicationsResponse } from '../../generic/communications-response/communications-response';
import { CommunicationsResponseSchema } from '../../generic/communications-response/communications-response-schema';

import { CommunicationsResponseGetSessionIdConstructor } from './communications-response-get-session-id-constructor';
import { CommunicationsResponseGetSessionIdError } from './communications-response-get-session-id-error';
import { CommunicationsResponseGetSessionIdSchema } from './communications-response-get-session-id-schema';

export class CommunicationsResponseGetSessionId extends CommunicationsResponse<CommunicationsResponseGetSessionIdError> {
  /////////////////////////////////////////////////////////////////////////////
  // Variables
  /////////////////////////////////////////////////////////////////////////////
  protected sessionId!: string;

  protected sessionType!: CommunicationSessionType | undefined;

  /////////////////////////////////////////////////////////////////////////////
  // Constructor
  /////////////////////////////////////////////////////////////////////////////
  constructor(parameters: CommunicationsResponseGetSessionIdConstructor) {
    (parameters as any)[CommunicationsResponseSchema.type] = CommunicationsRequestName.getSessionId;
    super(parameters);
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  /**
   * This static function is private, and meant to be called only by
   * SerializableObject, and subclasses
   *
   * @param validationResult
   */
  protected static _deserialize(validationResult: import('joi').ValidationResult): CommunicationsResponseGetSessionId {
    return new CommunicationsResponseGetSessionId(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////
  public serialize() {
    return super.serialize(CommunicationsResponseGetSessionId.getSchema());
  }

  /////////////////////////////////////////////////////////////////////////////
  // Schema
  /////////////////////////////////////////////////////////////////////////////
  public static getSchema(): SerializableObjectSchema {
    return new CommunicationsResponseGetSessionIdSchema();
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////
  public getSessionId(): string {
    return cloneDeep(this.sessionId);
  }

  public getSessionType(): CommunicationSessionType | undefined {
    return cloneDeep(this.sessionType);
  }
}
